import { buildSearchCriteriaParams, type SearchCriteria } from '@/entities/searchCriteria';
import NotFoundState from './NotFoundState';
import type { AlternativeSearchContext, AlternativeSearchState, AlternativeSearchView } from './types';
import { buildDefaultCriteria } from '../../lib/alternativeSearchCriteria';
import { hasSerpProducts } from '../../lib/toSerpProducts';

function isSameSearch(left: SearchCriteria, right: SearchCriteria): boolean {
  return JSON.stringify(buildSearchCriteriaParams(left)) === JSON.stringify(buildSearchCriteriaParams(right));
}

export default class DefaultCriteriaState implements AlternativeSearchState {
  readonly criteria: SearchCriteria | null;

  private readonly unsubscribe: () => void;

  constructor(private readonly context: AlternativeSearchContext) {
    const { formData, userCriteria } = context;
    const criteria = formData ? buildDefaultCriteria(userCriteria, formData) : null;

    this.criteria = criteria && !isSameSearch(criteria, userCriteria) ? criteria : null;

    this.unsubscribe = context.productSearch.on('end', (result) => {
      if (result.state !== 'finished' || hasSerpProducts(result)) return;

      context.setState(new NotFoundState());
    });
  }

  get view(): AlternativeSearchView | null {
    return this.criteria ? { kind: 'similar', criteria: this.criteria } : null;
  }

  start(): void {
    const { criteria, context } = this;

    if (!criteria) {
      context.setState(new NotFoundState());
      return;
    }

    context.productSearch.run(criteria);
  }

  dispose(): void {
    this.unsubscribe();
  }
}
